import React from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'
import FolderSvg from 'assets/components/add_to_folder/folder.svg'

import styles from './folder_item.scss'

const FolderItem = props => {
	const handleSelect = () => {
		props.handleSelect(props.id)
	}
	return (
		<div
			styleName='wrapper'
			onClick={handleSelect}
		>
			<img src={FolderSvg} alt='Folder Icon'/>
			<h2 styleName='item-folder-name'>
				{props.name}
			</h2>
		</div>
	)
}

FolderItem.propTypes = {
	name: PropTypes.string.isRequired,
	handleSelect: PropTypes.func.isRequired,
	id: PropTypes.string.isRequired,
}

export default CSSModules(FolderItem, styles, { allowMultiple: true })
